import { Controller } from "@hotwired/stimulus";

/**
 * 規約同意モーダル（remodal）を制御する controller。
 *
 * targets:
 * - check: 同意チェックボックス（複数）
 * - accept: 同意ボタン
 *
 * values:
 * - publishedAt: 同意済み判定に使う日付（cookieに保存）
 * - manualOpen: true の場合は自動表示せず、`requestOpenTermModal` イベントで開く
 *
 * 挙動:
 * - すべてのチェックがONになるまで同意ボタンを無効化
 * - 同意時に cookie `show_term_date` を長期保存し、`termAccepted` を dispatch
 */
export default class extends Controller {
  static targets = ["check", "accept"];
  static values = {
    publishedAt: String,
    manualOpen: { type: Boolean, default: false }
  };

  modal = $("[data-remodal-id=modalTerm]").remodal({
    hashTracking: false,
    closeOnEscape: false,
    closeOnOutsideClick: false,
  });

  connect() {
    this.updateAcceptButtonEventListener = this.updateAcceptButton.bind(this);
    for (const checkBox of this.checkTargets) {
      checkBox.addEventListener("change", this.updateAcceptButtonEventListener);
    }
    this.updateAcceptButton();

    if (this.manualOpenValue) {
      document.addEventListener("requestOpenTermModal", this.openModal.bind(this));
    } else {
      this.openModal();
    }
  }

  disconnect() {
    for (const checkBox of this.checkTargets) {
      checkBox.removeEventListener("change", this.checkChangeEventListener);
    }

    if (this.manualOpenValue) {
      document.removeEventListener("requestOpenTermModal", this.openModal.bind(this));
    }
  }

  openModal() {
    this.modal.open();
  }

  submit() {
    document.cookie = `show_term_date=${this.publishedAtValue}; path=/; max-age=315360000;`; // 無期限
    this.element.dispatchEvent(new CustomEvent("termAccepted"));
    this.modal.close();
  }

  updateAcceptButton() {
    for (const checkBox of this.checkTargets) {
      if (!checkBox.checked) {
        this.disableAcceptButton();
        return;
      }
    }
    this.enableAcceptButton();
  }

  disableAcceptButton() {
    this.acceptTarget.disabled = true;
    this.acceptTarget.classList.add("is-disabled");
  }

  enableAcceptButton() {
    this.acceptTarget.disabled = false;
    this.acceptTarget.classList.remove("is-disabled");
  }
}
